import { Switch } from "@blueprintjs/core";
import React from "react";

import { SettingsReducer } from "./hooks";

export enum ArrowSize {
  SMALL = 1,
  MEDIUM = 2,
  LARGE = 3,
}

export interface SettingsProps {
  settingsReducer: SettingsReducer;
}

export const Settings = ({ settingsReducer }: SettingsProps) => {
  const { settings, toggleViewCourtBackground, toggleEnableActionPalette, toggleIncludeHashPass, toggleViewGrid } =
    settingsReducer;

  return (
    <div>
      <Switch checked={settings.viewCourtBgr} label="View court background" onChange={toggleViewCourtBackground} />
      <Switch
        checked={settings.enbActPalette}
        label="Enable choose action palette"
        onChange={toggleEnableActionPalette}
      />
      <Switch
        checked={settings.incHashPass}
        label="Include HashPass stencils on palette"
        onChange={toggleIncludeHashPass}
      />
      <Switch checked={settings.viewGrid} label="View grid" onChange={toggleViewGrid} />
    </div>
  );
};
